'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUIToggle = function AUIToggle() {
    for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
        props[_key] = arguments[_key];
    }

    return _react2.default.createElement('aui-toggle', props);
};

AUIToggle.displayName = 'AUIToggle';
exports.default = AUIToggle;
//# sourceMappingURL=AUIToggleButton.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/AUIToggleButton.js
// module id = 199
// module chunks = 0